export default __webpack_public_path__ + "static/media/what-we-offers-bg-2.27be0360.jpg";